import { render, staticRenderFns } from "./DemonstrativoFerias.vue?vue&type=template&id=187b0ce5&"
import script from "./DemonstrativoFerias.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoFerias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports